module.exports = __webpack_public_path__ + "static/media/sharedfile.12b6aab4.gif";